import {HttpClient, HttpResponse} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import {map, Observable} from 'rxjs';
import { saveAs } from 'file-saver';
export type EntityResponseType = HttpResponse<any>;
export type EntityArrayResponseType = HttpResponse<any[]>;

@Injectable({providedIn: 'root'})
export class FileRepositoryService {
  protected resourceUrl = `${environment.SERVER_EDITION_API_URL}/api/editions`;

  constructor(protected http: HttpClient) {}

  // getFile(id: number): Observable<any> {
  //   return this.http.get<any>(`${this.resourceUrl}/${id}`, {observe: 'body'});
  // }

  getFile(stockageId: number): Observable<Blob> {
    // Single endpoint URL - no format in path
    const url = `${this.resourceUrl}/download/${stockageId}`;

    return this.http
      .post(
        url,
        {},
        {
          responseType: 'blob',
          observe: 'response',
        }
      )
      .pipe(
        map((response) => {
          // Handle the file download
          const blob = response.body!;
          const fileName = response.headers.get('Filename');
          saveAs(blob, fileName);
          return blob;
        })
      );
  }
}
